import { CookieConsent } from '../enums';

export const WIDGET_DEFAULT_ATTRIBUTES = {
  cookieConsent: CookieConsent.Ask,
};
